import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const getProjectBankForms = async (
  projectId,
  { nextToken, limit } = {}
) => {
  const query = new URLSearchParams();

  if (nextToken) {
    query.set('nextToken', nextToken);
  }

  if (limit) {
    query.set('limit', String(limit));
  }

  const queryString = query.toString();
  const apiPath = `project-bank/${projectId}/forms${queryString ? `?${queryString}` : ''
    }`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
